import type { SVGProps } from "react";
// generated from Copy.svg — do not edit manually
// prettier-ignore
export default function Copy(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 16 8 V 2 H 2 V 16 H 8 M 16 8 V 16 H 8 M 16 8 H 22 V 22 H 8 V 16" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
